export default "__VITE_ASSET__f526af64__"